<template>
<div>
<p>
Shareholder summary coming soon!
</p>
</div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Shareholders'
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Shareholders.vue